import * as type from "../../types/API/paymentTerm";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getPaymentTermReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_PAYMENT_TERMS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PAYMENT_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_PAYMENT_TERMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addPaymentTermReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_PAYMENT_TERMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_PAYMENT_TERMS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_PAYMENT_TERMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editPaymentTermReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_PAYMENT_TERMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_PAYMENT_TERMS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_PAYMENT_TERMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deletePaymentTermReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_PAYMENT_TERMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_PAYMENT_TERMS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_PAYMENT_TERMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 